import React, { useEffect } from "react";
import { Form, InputNumber, Button, Select, Input } from "antd";
import { createRedemCode } from "../../features/redem-code/redemCodeSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message as msg } from "antd";
const { Option } = Select;

const CreateRedemCode = () => {
  const [messageApi, contextHolder] = msg.useMessage();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, creating, message, isCreateSuccess } = useSelector(
    (state) => state.redemCode
  );

  const onFinish = (data) => {
    dispatch(createRedemCode(data));
  };

  useEffect(() => {
    if (isError && message) {
      messageApi.open({
        type: "error",
        content: message,
      });
    }

    if (isCreateSuccess) {
      messageApi.open({
        type: "success",
        content: "Redem Code created successfully",
      });
    }

    if (isCreateSuccess) {
      navigate("/admin/redem-code");
    }
  }, [isError, message, isCreateSuccess, messageApi, navigate]);

  return (
    <div>
      {contextHolder}
      <h3 className="mb-4 title">Redem Code</h3>
      <Form
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ period: "day", status: "1", type: "price" }}
      >
        <Form.Item
          label="Code"
          name="code"
          rules={[{ required: true, message: "Please input the redem code!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Hole In One Credit"
          name="hole_in_one_credits"
          rules={[{ required: true, message: "Please input the Hole In One credits!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Hole Out Credit"
          name="hole_out_credits"
          rules={[{ required: true, message: "Please input the Hole Out credits!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Total Redemption Limit"
          name="total_redemption_limit"
          rules={[{ required: true, message: "Please input the total redemption limit!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Status"
          name="status"
          rules={[{ required: true, message: "Please select the status!" }]}
        >
          <Select>
            <Option value="1">Active</Option>
            <Option value="0">Inactive</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" disabled={creating}>
            {creating ? "Submitting..." : "Submit"}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreateRedemCode;
